// src/pages/design/Dcn_view.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MobileFormViewManager from "../../components/common/mobile/MobileFormViewManager";
import MobileShareButton from "../../components/common/mobile/MobileShareButton";
import { applyDesignFilesFromDCN } from "../../api/design/file";
import PeopleView from "../../components/common/people/PeopleView";
import TinyMCEpreview from "../../components/const/TinyMCEpreview";
import { getDocPersons } from "../../api/papers";
import { changeDocState } from "../../api/design/meta";

export default function Dcn_view() {
  const { id: project, dns } = useParams();

  return (
    <div className="mobile-page-root mb-16">
      <div className="mobile-page-root-inner">
        <MobileFormViewManager
          params={{
            module: "design",
            doc_type: "DCN",
            project,
            dns,
          }}
          doc_name={"설계변경도면 (DCN)"}
        >
          <DcnViewContent project={project} dns={dns} />
        </MobileFormViewManager>
      </div>
    </div>
  );
}

function DcnViewContent({ meta, data, project, dns }) {
  const rows = (meta?.details || []).map((r, i) => ({
    no: i + 1,
    ...r,
  }));

  const me = JSON.parse(localStorage.getItem("user") || "{}");
  const myUserId = me?.id || me?.user?.id;

  const [people, setPeople] = useState([]);

  useEffect(() => {
    const loadPeople = async () => {
      try {
        const list = await getDocPersons(dns);
        setPeople(list || []);
      } catch (error) {
        console.error("❌ 담당자 로드 오류:", error);
        setPeople([]);
      }
    };
    loadPeople();
  }, [dns]);

  const isAssignee = people.some(
    (p) => p.id === myUserId || p.userId === myUserId || p.user_id === myUserId
  );

  const docState =
    data?.state ?? meta?.state ?? data?.status ?? meta?.status ?? null;

  const canReject = isAssignee && docState === "save";

  const handleReject = async () => {
    if (!window.confirm("DCN 요청을 반려하시겠습니까?")) return;
    try {
      await changeDocState(dns, "reject");
      alert("반려 처리되었습니다. 담당자가 다시 수정할 수 있습니다.");
      window.location.reload();
    } catch (e) {
      console.error(e);
      alert("반려 처리 중 오류가 발생했습니다.");
    }
  };

  const handleApplyToLibrary = async () => {
    const fileCount = data?.files?.length || 0;

    const confirmText =
      fileCount > 0
        ? `총 ${fileCount}개의 도면을 라이브러리에 반영하시겠습니까?`
        : "첨부된 도면이 없습니다.\n그래도 반영 처리(기록)는 진행됩니다.";

    if (!window.confirm(confirmText)) return;

    try {
      const res = await applyDesignFilesFromDCN(project, dns);

      await changeDocState(dns, "complete");

      alert(res.message || "라이브러리 반영 완료 및 문서 상태 완료 처리");
      window.location.reload();
    } catch (err) {
      console.error("❌ DCN 라이브러리 반영 실패:", err);
      alert("라이브러리 반영 실패");
    }
  };

  const sectionStyle = "rounded-lg border bg-white p-3 min-w-0 w-full";

  return (
    <div className="mobile-page-root mb-16">
      <div className="mobile-page-root-inner space-y-3">
        {/* 발행 정보 */}
        <section className={sectionStyle}>
          <div className="text-sm font-semibold mb-4 text-gray-900">
            발행 정보
          </div>

          <div className="space-y-4 min-w-0 w-full">
            {/* 검토 담당자 */}
            <div className="flex flex-col gap-1.5 min-w-0 w-full border-b border-gray-100 pb-3">
              <div className="text-xs text-gray-600 font-medium">검토 담당자</div>
              <div className="text-sm text-gray-900 break-words leading-relaxed">
                <PeopleView dns={dns} placeholder="지정된 담당자 없음" />
              </div>
            </div>

            {/* 발행 사유 */}
            {meta?.reason && (
              <div className="flex flex-col gap-1.5 min-w-0 w-full">
                <div className="text-xs text-gray-600 font-medium">발행 사유</div>
                <div className="text-sm text-gray-900 break-words leading-relaxed min-w-0 w-full">
                  <TinyMCEpreview html={meta.reason} />
                </div>
              </div>
            )}
          </div>
        </section>

        {/* 변경 도면 내역 */}
        <section className={sectionStyle}>
          <div className="text-sm font-semibold mb-4 text-gray-900">
            변경 도면 내역
          </div>

          {/* 라이브러리 적용 버튼 */}
          <div className="mb-4 no-print">
            <button
              onClick={handleApplyToLibrary}
              className="btn-create text-sm px-4 py-2.5 w-full sm:w-auto flex-shrink-0 whitespace-nowrap"
            >
              변경도면 라이브러리에 적용
            </button>
          </div>

          <div className="space-y-3 min-w-0 w-full">
            {rows.length > 0 ? (
              rows.map((r, idx) => {
                const fileUrl =
                  r.drawingFileUrl ||
                  (r.drawingFileId
                    ? `/project/${project}/design/library/doc/${r.drawingFileId}`
                    : null);
                const fileIdx = Number(r.index ?? r.no - 1);
                const file = data.files?.[fileIdx];

                return (
                  <div
                    key={r.no || idx}
                    className="border border-gray-200 rounded-lg p-3 bg-gray-50 space-y-2 min-w-0 w-full"
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-xs font-medium text-gray-600">
                        No.
                      </span>
                      <span className="text-sm font-semibold text-gray-900">
                        {r.no}
                      </span>
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <div className="text-xs text-gray-600 font-medium">
                        도면번호
                      </div>
                      <div className="text-sm text-gray-900 break-words">
                        {fileUrl ? (
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline hover:text-blue-700"
                          >
                            {r.drawingNo || "도면보기"}
                          </a>
                        ) : (
                          <span>{r.drawingNo || "-"}</span>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <div className="text-xs text-gray-600 font-medium">
                        버전
                      </div>
                      <div className="text-sm text-gray-900 break-words">
                        {r.version || "-"}
                      </div>
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <div className="text-xs text-gray-600 font-medium">
                        변경 내용
                      </div>
                      <div className="text-sm text-gray-900 break-words">
                        {r.changeDesc || "-"}
                      </div>
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <div className="text-xs text-gray-600 font-medium">
                        첨부 도면
                      </div>
                      <div className="text-sm text-gray-900 break-words">
                        {file ? (
                          <a
                            href={file.file_url}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-600 underline"
                          >
                            {file.file_name || "파일 보기"}
                          </a>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="text-center text-sm text-gray-400 py-4">
                변경 도면 내역이 없습니다.
              </div>
            )}
          </div>
        </section>

        {/* 연결 안내 */}
        {meta?.related_doc && (
          <section className={sectionStyle}>
            <div className="text-xs text-gray-500 italic">
              ※ 본 문서는 FCN ({meta.related_doc}) 통보서를 기반으로
              발행되었습니다.
            </div>
          </section>
        )}

        {/* 액션 버튼 (반려) */}
        {canReject && (
          <section className={`${sectionStyle} no-print`}>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full">
              <button
                onClick={handleReject}
                className="btn-delete text-sm px-4 py-2.5 flex-1 sm:flex-initial flex-shrink-0 whitespace-nowrap"
              >
                반려
              </button>
              <MobileShareButton
                title={`설계변경도면 (DCN)`}
                className="flex-shrink-0"
              />
            </div>
          </section>
        )}
      </div>
    </div>
  );
}
